var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Navbar'),_c('div',{staticClass:"mx-3 my-3"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }